import { render, staticRenderFns } from "./StFontSizes.vue?vue&type=template&id=2d469ecc"
import script from "./StFontSizes.vue?vue&type=script&lang=ts"
export * from "./StFontSizes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports